import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-beta-test',
  imports: [],
  templateUrl: './beta-test.component.html',
  styleUrl: './beta-test.component.scss'
})
export class BetaTestComponent {
  private readonly router = inject(Router);

  protected goBack(): void {
    this.router.navigate(['/']);
  }

}
